export default "__VITE_ASSET__CkryvTKz__"